<coin-v2-dialog-frame [header]="'shared.incentive.monitoring.auto-finalize-dialog.autofinalize' | translate">
  <div class="selection">
    <coin-v2-text-input
      [placeholder]="'general.enter-value' | translate"
      [label]="'shared.incentive.monitoring.auto-finalize-dialog.finalize-message-label' | translate"
      [(ngModel)]="message"></coin-v2-text-input>
    <coin-v2-date-input
      required
      [label]="'shared.incentive.monitoring.auto-finalize-dialog.finalize-date-label' | translate"
      [placeholder]="'general.click-to-select' | translate"
      [formControl]="dateFormControl" />
  </div>
  <coin-v2-dialog-footer color="white">
    <div class="v2-footer-spacer"></div>
    <coin-v2-button
      type="secondary"
      icon="close"
      iconPos="right"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
    <coin-v2-button
      type="primary"
      icon="add"
      iconPos="right"
      [text]="'general.create' | translate"
      [disabled]="!isValidToCreate"
      (click)="create()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
